module.exports = __webpack_public_path__ + "img/avatar.f75f91dd.png";